/*
  c-product-media-clickzones.js (PM 0507 #3 / P-03 商品詳細)
  PC のみ (>= 750px) で、商品メイン画像の左半分クリック → 前画像 / 右半分クリック → 次画像。
  Dawn の <media-gallery> 内 .slider-button--prev / --next を click() で発火させて既存 slider 挙動を流用。
  SP は既存 swipe + 左右矢印ボタンの UI で対応 (clickzone 非表示 = CSS 制御)。
*/
(function () {
  function initGallery(gallery) {
    if (gallery.dataset.cClickzonesInit === '1') return;
    gallery.dataset.cClickzonesInit = '1';

    /* メイン画像 slider-component を取得 (サムネ用 thumbnail-slider は除外)。
       Dawn 構造: <media-gallery> > <slider-component> (メイン) + <slider-component class="thumbnail-slider"> (サムネ) */
    var mainSlider = gallery.querySelector('slider-component:not(.thumbnail-slider)');
    if (!mainSlider) return;

    /* 仕様: 1px 線 / 幅 10px × 高 20px の chevron。viewBox 10x20 で path を縦方向に描画 */
    var prevSvg = '<svg width="10" height="20" viewBox="0 0 10 20" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M9 1L1 10L9 19" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var nextSvg = '<svg width="10" height="20" viewBox="0 0 10 20" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M1 1L9 10L1 19" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    /* PC では .product__media-list が grid 表示のため Dawn の SliderComponent.onButtonClick の
       scrollLeft 制御が機能しない (画像はループ表示)。
       代わりに media-gallery.setActiveMedia(mediaId, false) を直接呼ぶ Dawn 標準ルートで切替 */
    function navigate(direction) {
      var items = mainSlider.querySelectorAll('.product__media-list > .product__media-item');
      if (!items.length) return;

      var activeIdx = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-active')) { activeIdx = i; break; }
      }
      if (activeIdx < 0) activeIdx = 0;

      var nextIdx;
      if (direction === 'next') {
        nextIdx = (activeIdx + 1) % items.length;
      } else {
        nextIdx = (activeIdx - 1 + items.length) % items.length;
      }

      var nextMediaId = items[nextIdx].dataset.mediaId;
      if (typeof gallery.setActiveMedia === 'function' && nextMediaId) {
        gallery.setActiveMedia(nextMediaId, false);
      }
    }

    var slides = mainSlider.querySelectorAll('.product__media-list .product__media-item.slider__slide');
    slides.forEach(function (slide) {
      if (slide.querySelector('.c-media-clickzone')) return;

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'c-media-clickzone c-media-clickzone--prev';
      prev.setAttribute('aria-label', '前の画像へ');
      prev.innerHTML = '<span class="c-media-clickzone__icon">' + prevSvg + '</span>';
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        navigate('prev');
      });

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'c-media-clickzone c-media-clickzone--next';
      next.setAttribute('aria-label', '次の画像へ');
      next.innerHTML = '<span class="c-media-clickzone__icon">' + nextSvg + '</span>';
      next.addEventListener('click', function (e) {
        e.preventDefault();
        navigate('next');
      });

      slide.appendChild(prev);
      slide.appendChild(next);
    });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
